// Locale Vuex

import state from './localeStates.js'
import * as getters from './localeGetters.js'
import * as mutations from './localeMutations.js'
import * as actions from './localeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
